export const QueryParam = {
  // shared
  ACTION: 'action',
  CREATE_DEBTOR: 'createDebtor',
  CREATE_PERMANENT_DEBT: 'createPermanentDebt',
  DELETE: 'delete',
  PREVIEW: 'preview',
  REDIRECT: 'redirect',
  RELOAD_ON_ERROR: 'reloadOnError',
  SHOW_NOTIFICATIONS: 'showNotifications',
  SHOW_VIDEO: 'showVideo',
  TAB: 'tab',
  TAG: 'tag',
  UPLOAD_VOUCHER: 'uploadVoucher',

  // tables
  ITEMS_PER_PAGE: 'itemsPerPage',
  PAGE: 'page',
  SORT_BY: 'sortBy',
  SORT_DESC: 'sortDesc',

  // overlayed
  OVERLAY__DATE: 'overlay__date',
  OVERLAY__PAGE: 'overlay__page',
  OVERLAY__STATUS: 'overlay__status',

  // onboarding
  SELECTED_PRODUCT_TYPE: 'selectedProductType',
  STEP: 'step',

  // auth
  RESET_PASSWORD: 'resetPassword',
  CHANGE_PASSWORD: 'changePassword',
  EXPIRED: 'expired',
  USE_TOKEN: 'useToken',

  // debtors
  ACTIVATE: 'activate',
  ADD_LOCATION: 'addLocation',
  CHECK_SOLVENCY: 'checkSolvency',
  DEACTIVATE: 'deactivate',
  DELETE_POST_ADDRESS: 'deletePostAddress',
  EDIT_DEBTOR: 'editDebtor',
  EDIT_LOCATION: 'editLocation',
  EDIT_PAYMENT_DATA: 'editPaymentData',
  EDIT_POST_ADDRESS: 'editPostAddress',
  REFRESH_LIMIT: 'refreshLimit',
  REQUEST_LIMIT_INCREASE: 'requestLimitIncrease',
  UPLOAD_INVOICE: 'uploadInvoice',

  // permanent debts
  STOP_PERMANENT_DEBT: 'stopPermanentDebt',

  // settings
  CREATE_COMPANY_USER: 'createCompanyUser',
  DELETE_COMPANY_USER: 'deleteCompanyUser',
  EDIT_COMPANY_USER: 'editCompanyUser',
  RESET_COMPANY_USER_PASSWORD: 'resetCompanyUserPassword',

  // unprocessed
  CANCEL: 'cancel',
  CONTINUE: 'continue',
  DELETE_ATTACHMENT: 'deleteAttachment',
  REUPLOAD: 'reupload',
  TRANSFER_BASIC_PROCESSING: 'transferBasicProcessing',

  // vouchers
  ABANDONMENT: 'abandonment',
  ANNULATION: 'annulation',
  CANCEL_DUNNING_BLOCK: 'cancelDunningBlock',
  CLOSE_DELAY: 'closeDelay',
  CLOSE_DISPUTE: 'closeDispute',
  CREDIT_ADVICE: 'creditAdvice',
  DIRECT_PAYMENT: 'directPayment',
  EDIT_COMMENT: 'editComment',
  OPEN_DELAY: 'openDelay',
  OPEN_DISPUTE: 'openDispute',
  SET_DUNNING_BLOCK: 'setDunningBlock',
  SHOW_BALANCING_SUMMARY: 'showBalancingSummary'
};

export default QueryParam;
